"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var Surface = /** @class */ (function (_super) {
    tslib_1.__extends(Surface, _super);
    function Surface(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setExposedRef = function (el) {
            var exposedRef = _this.props.exposedRef;
            exposedRef && exposedRef(el);
        };
        return _this;
    }
    Surface.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, className = _b.className, theme = _b.theme, level = _b.level, style = _b.style, exposedRef = _b.exposedRef, margin = _b.margin, padding = _b.padding, inner = _b.inner, others = tslib_1.__rest(_b, ["children", "className", "theme", "level", "style", "exposedRef", "margin", "padding", "inner"]);
        var levelDepth = level < 0 ? "inset" + level : level;
        var surfaceStyle = tslib_1.__assign({}, style, { margin: margin,
            padding: padding });
        var classes = classnames_1.default(theme.surface, className, [theme["level-" + levelDepth]], (_a = {},
            _a[theme.inner] = inner,
            _a));
        return (React.createElement("div", tslib_1.__assign({ className: classes, ref: this.setExposedRef, style: surfaceStyle }, others), children));
    };
    Surface.defaultProps = {
        level: 1
    };
    return Surface;
}(React.Component));
exports.default = Surface;
